import { render, staticRenderFns } from "./SensorValues.vue?vue&type=template&id=0cc50c42&scoped=true"
import script from "./SensorValues.vue?vue&type=script&lang=ts"
export * from "./SensorValues.vue?vue&type=script&lang=ts"
import style0 from "./SensorValues.vue?vue&type=style&index=0&id=0cc50c42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc50c42",
  null
  
)

export default component.exports